import { formBreakpoint } from 'globalStyles'
import styled from 'styled-components'
import { InputBase } from 'utils/base'

export const Wrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 1px solid var(--grey-400);
  border-radius: 0.6rem;
  pointer-events: none;
  background-color: var(--light);
  z-index: -1;
`

export const InputContainer = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;

  position: relative;
  width: 30rem;
  height: 4rem;
  padding: 0 1.2rem;
  max-width: 100%;

  & > input:focus + div,
  &:hover > input + div {
    box-shadow: 0 1px 1px 0 var(--shadow), 0 0 0 2px var(--brand-600);
    border-color: transparent;
  }

  @media (max-width: ${formBreakpoint}) {
    width: 100%;
  }
`

export const Input = styled(InputBase)`
  padding: 0.8rem 0 0.8rem 1.2rem;
  color: var(--text-dark);
  line-height: 2.4rem;
`

export const Decoration = styled.div`
  display: flex;
  align-items: center;
  white-space: nowrap;
  color: var(--text-light);
`
